import axios from 'axios';
import React from 'react'
import { baseUrl } from '../assets/Animations';
import './ugly-cancellations.css'
import UglyCancellationsPopup from './UglyCancellationsPopup/UglyCancellationsPopup';
const UglyCancellations = () => {
    const [cancellations, setCancellations] = React.useState([])
    const [teacherCancelled, setTeacherCancelled] = React.useState({})
    const [familyCancelled, setFamilyCancelled] = React.useState({})
    const [teacherCancellations, setTeacherCancellations] = React.useState([])
    const [familyCancellations, setFamilyCancellations] = React.useState([])
    const [showPopup, setShowPopup] = React.useState(false)

    React.useEffect(() => {
        axios.get(`${baseUrl}/cancellation`)
        .then(res => {setCancellations(res.data)})
        .catch(err => {console.log(err)})
    }, [])

    React.useEffect(() => {
        const teacherCancellations = cancellations.filter(cancellation => cancellation.teacherCancelled === true)
        const familyCancellation = cancellations.filter(cancellation => cancellation.teacherCancelled === false)
        setTeacherCancellations(teacherCancellations)
        setFamilyCancellations(familyCancellation)
        setTeacherCancelled(organizeCancellationsByTeacherName(teacherCancellations))
        setFamilyCancelled(organizeCancellationsByFamilyName(familyCancellation))
    }
    , [cancellations])

    //ORGANIZE CANCELLATIONS BY If teacherCancelled is true or not
    //if teacherCancelled is true, then ORGANIZE by teacherName
    //if teacherCancelled is false, then ORGANIZE by familyName

    const organizeCancellationsByFamilyName = (cancellations) => {
        const cancellationsByFamilyName = {}
        cancellations.forEach(cancellation => {
            if(!cancellationsByFamilyName[cancellation.familyName]) {
                cancellationsByFamilyName[cancellation.familyName] = []
            }
            cancellationsByFamilyName[cancellation.familyName].push(cancellation)
        })
        return sortByLongestArray(cancellationsByFamilyName)
    }

    const organizeCancellationsByTeacherName = (cancellations) => {
        const cancellationsByTeacherName = {}
        cancellations.forEach(cancellation => {
            if(!cancellationsByTeacherName[cancellation.teacherName]) {
                cancellationsByTeacherName[cancellation.teacherName] = []
            }
            cancellationsByTeacherName[cancellation.teacherName].push(cancellation)
        })
        //sort cancellationsbyteachername by who has the most cancellations


        return sortByLongestArray(cancellationsByTeacherName)
    }

    function sortByLongestArray(obj) {
        const keys = Object.keys(obj);
      
        keys.sort((key1, key2) => {
          const arrayLength1 = Array.isArray(obj[key1]) ? obj[key1].length : 0;
          const arrayLength2 = Array.isArray(obj[key2]) ? obj[key2].length : 0;
          return arrayLength2 - arrayLength1;
        });
      
        const sortedObj = {};
        keys.forEach(key => {
          sortedObj[key] = obj[key];
        });
      
        return sortedObj;
      }



      return (
        <div className="cancellation-container">
          <div className="cancellation-column">
            <div className='cancellation-header'>Family Cancellations: {teacherCancellations.length}</div>
            <div className='cancellations-wrapper'>
              {Object.keys(familyCancelled).map((key) => (
                <div
                  className='each-cancellation'
                  onClick={() => setShowPopup(familyCancelled[key])}
                >
                  {key}: {familyCancelled[key].length}
                </div>
              ))}
            </div>
          </div>
          <div className="cancellation-column">
            <div className='cancellation-header'>Teacher Cancellations: {familyCancellations.length}</div>
            <div className='cancellations-wrapper'>
              {Object.keys(teacherCancelled).map((key) => (
                <div
                  className='each-cancellation'
                  onClick={() => setShowPopup(teacherCancelled[key])}
                >
                  {key}: {teacherCancelled[key].length}
                </div>
              ))}
            </div>
          </div>
          {showPopup && <UglyCancellationsPopup cancellations={showPopup} setShowPopup={setShowPopup} />}
        </div>
      );
}
export default UglyCancellations;